export const FEATURES = "features";

export const FEATURE_STAMPS = {
    // COULDDO/PROSPECTIVE: seven steps, more closely linked with days of creation
    PROSPECTIVE: "prospective",
    COMMITTED: "committed",
    COMMENCED: "commenced",
    DEPLOYED: "deployed",
    ACCEPTED: "accepted"
}; 

export const STAMP_SEQUENCE = [
    FEATURE_STAMPS.PROSPECTIVE,
    FEATURE_STAMPS.COMMITTED,
    FEATURE_STAMPS.COMMENCED,
    FEATURE_STAMPS.DEPLOYED,
    FEATURE_STAMPS.ACCEPTED
];